import { useNavigate } from 'react-router-dom';
import { Brief } from './hub/Brief';
import { PinnedStrip } from './hub/PinnedStrip';
import { SuiteSection } from './hub/SuiteSection';
import { Workspaces } from './hub/hub-rail/Workspaces';
import { Alerts } from './hub/hub-rail/Alerts';
import { Recent } from './hub/hub-rail/Recent';
import { usePlatform } from '../data/queries/usePlatform';

export function Hub() {
  const navigate = useNavigate();
  const { data } = usePlatform();

  if (!data) return null;

  const goToSystem = (systemId: string, moduleId?: string) => {
    navigate(`/system/${systemId}${moduleId ? `/${moduleId}` : ''}`);
  };

  return (
    <div className="hub">
      <Brief brief={data.brief} suites={data.suites} goToSystem={goToSystem} />
      <PinnedStrip pinned={data.pinned} suites={data.suites} goToSystem={goToSystem} />
      <div className="hub-body">
        <div>
          {data.suites.map((suite, i) => (
            <SuiteSection
              key={suite.id}
              suite={suite}
              index={i + 1}
              goToSystem={goToSystem}
            />
          ))}
        </div>
        <aside className="hub-rail">
          <Workspaces workspaces={data.workspaces} />
          <Alerts alerts={data.alerts} suites={data.suites} goToSystem={goToSystem} />
          <Recent recent={data.recent} suites={data.suites} goToSystem={goToSystem} />
        </aside>
      </div>
    </div>
  );
}
